'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:TaskTemplateController
 * @description
 * # TaskTemplateController
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('TaskTemplateController', function (TaskTemplateService, NgTableParams, TASK_TYPE) {
        var vm = this;
        vm.hideAddTask = true;
        vm.hideEditTask = true;
        vm.showDelTaskTemplate = false;
        vm.showRemarkTaskTemplate = false;
        vm.disableTaskTable = false;
        vm.taskTypes = TASK_TYPE;
        vm.taskTemplateList = [];
        TaskTemplateService.query().$promise.then(function (data) {
            angular.forEach(data, function (taskTemplate) {
                vm.taskTemplateList.push(taskTemplate);
            });
            vm.tableParams.settings({
                dataset: vm.taskTemplateList
            });
        });

        vm.toogleDivOrDialog = function (dialog) {
            vm[dialog] = !vm[dialog];
        };

        vm.showEditTaskDiv = function (taskTemplate) {
            vm.selectedTaskTemplate = taskTemplate;
            vm.editTaskTemplate = angular.copy(taskTemplate);
            vm.disableTaskTable = true;
            vm.toogleDivOrDialog('hideEditTask');
        };

        vm.hideEditTaskDiv = function () {
            vm.disableTaskTable = false;
            vm.editTaskTemplate = undefined;
            vm.toogleDivOrDialog('hideEditTask');
        };

        vm.showDelTaskDialog = function (taskTemplate) {
            vm.selectedTaskTemplate = taskTemplate;
            vm.toogleDivOrDialog('showDelTaskTemplate');
        };

        vm.showRemarkTaskDialog = function (taskTemplate) {
            vm.selectedTaskTemplate = taskTemplate;
            vm.toogleDivOrDialog('showRemarkTaskTemplate');
        };

        vm.addTask = function (taskTemplate) {
            TaskTemplateService.save({ task: taskTemplate.task, days: taskTemplate.days, type: taskTemplate.type.id, remark: taskTemplate.remark }, function (data) {
                vm.taskTemplateList.push(data);
                vm.tableParams.settings({
                    dataset: vm.taskTemplateList
                });
                vm.toogleDivOrDialog('hideAddTask');
            });
        };

        vm.editTask = function () {
            TaskTemplateService.update(vm.editTaskTemplate, function (data) {
                vm.taskTemplateList.splice(vm.taskTemplateList.indexOf(vm.selectedTaskTemplate), 1);
                vm.taskTemplateList.push(data);
                vm.tableParams.settings({
                    dataset: vm.taskTemplateList
                });
                vm.hideEditTaskDiv();
            });
        };

        vm.delTask = function () {
            TaskTemplateService.delete(vm.selectedTaskTemplate, function () {
                vm.taskTemplateList.splice(vm.taskTemplateList.indexOf(vm.selectedTaskTemplate), 1);
                vm.tableParams.settings({
                    dataset: vm.taskTemplateList
                });
                vm.toogleDivOrDialog('showDelTaskTemplate');
            });
        };

        vm.cols = [
            { valueExpr: 'taskTemplate.task', title: 'Aufgabe', sortable: 'task', filter: { task: 'text' }, show: true },
            { valueExpr: 'taskTemplate.days', title: 'Tage', sortable: 'days', filter: { days: 'number' }, show: true },
            {
                valueExpr: 'taskTemplate.type',
                title: 'Art',
                sortable: 'type',
                filter: { type: 'select' },
                filterData: TASK_TYPE,
                show: true
            },
            { field: 'action', title: '', dataType: 'command', class: 'actionWidth150' }
        ];

        vm.tableParams = new NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            dataset: vm.taskTemplateList
        });
    });
